import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

export const TOKEN_KEY = "qwiklogs_token";
export const ACTIVITY_KEY = "qwiklogs_last_activity";
export const lastActivity = () => Number(localStorage.getItem(ACTIVITY_KEY) || Date.now());

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (Date.now() - lastActivity() < 120000) config.headers["X-User-Active"] = "1";
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config?.skipAuthRedirect) {
      localStorage.removeItem(TOKEN_KEY);
      const idle = String(err.response?.data?.detail || "").includes("inactivity");
      if (!window.location.pathname.match(/\/(login|signup)?$/)) {
        window.location.href = idle ? "/login?expired=idle" : "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function localISO() {  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  const off = -d.getTimezoneOffset();
  const s = off >= 0 ? "+" : "-";
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}${s}${p(Math.floor(Math.abs(off) / 60))}:${p(Math.abs(off) % 60)}`;
}

export const isAdmin = (u) => ["manager", "admin", "hr", "super_admin"].includes(u?.role);
export const isSuperAdmin = (u) => u?.role === "super_admin";
export const can = (u, perm) => u?.role === "super_admin" || (u?.permissions || []).includes(perm);

export default api;
